import { createElement } from "react";
import { hydrateRoot } from "react-dom/client";

import Help from "./Help";
import { initializeClient } from "../../utils/clientInit";


const attributeValue = (attributeName: string) => {
  const scriptTag = document.getElementById("js");
  return scriptTag.getAttribute(`data-prop-${attributeName}`) || "";
};

const contentDataEl = document.getElementById("content-data");
const contentData = contentDataEl ? JSON.parse(contentDataEl.textContent || "{}") : {};

const props = {
  amount: parseInt(attributeValue("amount"), 10),
  storeLogo: attributeValue("store-logo"),
  storeName: attributeValue("store-name"),
  faqList: contentData.faqList || [],
};

// Initialize client-side services (non-blocking)
initializeClient();

// Hydrate immediately to ensure interactivity
hydrateRoot(document.getElementById("app"), createElement(Help, props));
